export const updateProperty = (obj, path, value = {}) => {
    const lastKey = path.pop();
    const tree = path.reduce((obj, key) => (obj[key] = obj[key] || {}), obj);
    tree[lastKey] = value;

    return tree;
};
